import React, { useState } from 'react'
import { Form, Input, Button, Card, Typography, Space, Divider } from 'antd'
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

const { Title, Text } = Typography

const LoginPage = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (values) => {
    setLoading(true)
    
    try {
      const result = await login(values)
      
      if (result.success) {
        navigate('/dashboard', { replace: true })
      }
    } catch (error) {
      console.error('Login error:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      <Card className="login-form" bordered={false}>
        <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
          {/* Logo/Brand */}
          <div>
            <Title level={2} className="login-title">
              ระบบจัดการธุรกิจ
            </Title>
            <Text type="secondary" className="login-subtitle">
              Enterprise Resource Planning
            </Text>
          </div>

          <Divider />

          {/* Login Form */}
          <Form
            form={form}
            name="login"
            layout="vertical"
            onFinish={handleSubmit}
            size="large"
            requiredMark={false}
            style={{ width: '100%' }}
          >
            <Form.Item
              name="email"
              label="อีเมล"
              rules={[
                {
                  required: true,
                  message: 'กรุณาระบุอีเมล'
                },
                {
                  type: 'email',
                  message: 'รูปแบบอีเมลไม่ถูกต้อง'
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="กรุณาระบุอีเมลของคุณ"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="รหัสผ่าน"
              rules={[
                {
                  required: true,
                  message: 'กรุณาระบุรหัสผ่าน'
                }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="กรุณาระบุรหัสผ่านของคุณ"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<LoginOutlined />}
                block
                size="large"
                style={{
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: 500
                }}
              >
                {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
              </Button>
            </Form.Item>
          </Form>

          {/* Demo credentials */}
          <div style={{ marginTop: 24 }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              พัฒนาโดย บริษัท อะตอมซอฟท์ จำกัด
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  )
}

export default LoginPage